import {createNav, main, navigateToHref, router, routes, setBreadcrumb, setTitle, switchTo} from './main.js';
import {requestJSON} from './utils.js';

let subnavItems = [
	{
		name: "Přátelé",
		routeName: "friend.list",
	},
	{
		name: "Uživatelé",
		routeName: "user.list",
	},
	{
		name: "Já",
		routeName: "me",
	},
	{
		name: "Pozvat",
		routeName: "friend.invite",
	},
];

function showFriends() {
	setTitle("Přátelé");
	setBreadcrumb([{title: "Přátelé"}]);
	switchTo(document.querySelector(".js-nav-friends"));

	// Load friends
	requestJSON('POST', routes["friend.list"], null, function (xhr) {
		let friends = xhr.response;

		main.textContent = '';

		let elem = document.createElement("section");
		elem.classList.add("tile");
		elem.appendChild(createNav(subnavItems, 0));

		let friendsElem = document.createElement("div");
		friendsElem.classList.add("list-group");
		elem.appendChild(friendsElem);

		for (let id in friends) {
			let friend = friends[id];
			let friendLink = document.createElement("a");
			friendLink.classList.add("list-group-item");
			friendLink.href = router.generateUrl("user.detail", {id: friend.friend_id});
			friendLink.addEventListener("click", navigateToHref);
			friendLink.textContent = friend.display_name;

			friendsElem.appendChild(friendLink);
		}

		main.appendChild(elem);
	});
}

function showInviteFriend() {
	setTitle("Pozvání");
	setBreadcrumb([
		{title: "Přátelé", url: router.generateUrl("friend.list")},
		{title: "Pozvání"}
	]);
	switchTo(document.querySelector(".js-nav-friends"));

	main.textContent = '';

	let elem = document.createElement("section");
	elem.classList.add("tile");
	elem.appendChild(createNav(subnavItems, 3));
	elem.insertAdjacentHTML("beforeend", `
<div class="tile-body">
	<form action="${routes["friend.invite"]}" method="POST">
		<p>
			<label for="display-name" class="form-label">Zobrazované jméno</label>
			<input type="text" class="form-control" id="display-name" name="display_name">
		</p>

		<p>
			<label for="first-name" class="form-label">Jméno</label>
			<input type="text" class="form-control" id="first-name" name="first_name">
		</p>

		<p>
			<label for="last-name" class="form-label">Příjmení</label>
			<input type="text" class="form-control" id="last-name" name="last_name">
		</p>

		<p>
			<label for="email" class="form-label">E-mail</label>
			<input type="text" class="form-control" id="email" name="email">
		</p>

		<button class="btn" type="submit">Pozvat</button>
	</form>
</div>`);

	main.appendChild(elem);

	let form = main.querySelector("form");
	form.addEventListener("submit", e => {
		e.preventDefault();

		let fd = new FormData(form);
		form.disabled = true;

		requestJSON(form.method, form.action, Object.fromEntries(fd.entries()), function (xhr) {
			let data = xhr.response;
			form.insertAdjacentHTML("afterend", `<div>${data.token}</div>`);
			form.disabled = false;
			form.reset();
		});
	});
}

function showMe() {
	showUserDetail({id: null});
}

function showUserDetail(attributes) {
	requestJSON('POST', routes["user.detail"], {id: attributes.id}, function (xhr) {
		let data = xhr.response;

		setTitle(data.display_name);
		setBreadcrumb([
			{title: "Uživatelé", url: router.generateUrl("user.list")},
			{title: data.display_name}
		]);
		switchTo(document.querySelector(".js-nav-friends"));

		main.textContent = '';
		main.insertAdjacentHTML("afterbegin", `<section class="tile">
	<div class="tile-header">
		<h2>${data.display_name}</h2>
		<a><i class="fas fa-edit"></i> Upravit</a>
	<div class="tile-body">
		<dl>
			<dt>Zobrazované jméno</dt>
			<dd>${data.display_name}</dd>

			<dt>Jméno</dt>
			<dd>${data.first_name}</dd>

			<dt>Příjmení</dt>
			<dd>${data.last_name}</dd>

			<dt>E-mail</dt>
			<dd>${data.email}</dd>
		</dl>
	</div>
</section>`);

		let editLink = main.querySelector("section > .tile-header > a");
		editLink.href = router.generateUrl("user.edit", {id: attributes.id});
		editLink.addEventListener("click", navigateToHref);
		// TODO:
		editLink.remove();
	});
}

function showUserEdit(attributes) {
	requestJSON('POST', routes["user.detail"], {id: attributes.id}, function (xhr) {
		let data = xhr.response;

		setTitle(data.display_name);
		setBreadcrumb([
			{title: "Uživatelé", url: router.generateUrl("user.list")},
			{title: data.display_name, url: router.generateUrl("user.detail", {id: attributes.id})},
			{title: "Úpravy"}
		]);
		switchTo(document.querySelector(".js-nav-friends"));

		main.textContent = '';
		main.insertAdjacentHTML("afterbegin", `<section class="tile">
	<div class="tile-body">
		<form disabled>
			<p>
				<label for="display-name" class="form-label">Zobrazované jméno</label>
				<input type="text" class="form-control" id="display-name" name="display_name" value="${data.display_name}">
			</p>

			<p>
				<label for="first-name" class="form-label">Jméno</label>
				<input type="text" class="form-control" id="first-name" name="first_name" value="${data.first_name}">
			</p>

			<p>
				<label for="last-name" class="form-label">Příjmení</label>
				<input type="text" class="form-control" id="last-name" name="last_name" value="${data.last_name}">
			</p>

			<p>
				<label for="email" class="form-label">E-mail</label>
				<input type="email" class="form-control" id="email" name="email" value="${data.email}">
			</p>
		</form>
	</div>
</section>`);

		if (attributes.id === null) {
			// Me
			main.querySelector("form").insertAdjacentHTML("beforeend", `
			<p>
				<label for="password" class="form-label">Heslo</label>
				<input type="password" class="form-control" id="password" name="password">
			</p>

			<p>
				<label for="password-again" class="form-label">Heslo znovu</label>
				<input type="password" class="form-control" id="password-again" name="password_again">
			</p>`);
		}

		main.querySelector("form").insertAdjacentHTML("beforeend", `
			<button class="btn" type="submit"><i class="fas fa-save"></i> Uložit</button>`);
	});
}

function showUserList() {
	setTitle("Uživatelé");
	setBreadcrumb([{title: "Uživatelé"}]);
	switchTo(document.querySelector(".js-nav-friends"));

	// Load users
	requestJSON('POST', routes["user.list"], null, function (xhr) {
		let users = xhr.response;

		main.textContent = '';

		let elem = document.createElement("section");
		elem.classList.add("tile");
		elem.appendChild(createNav(subnavItems, 1));

		let usersElem = document.createElement("div");
		usersElem.classList.add("list-group");
		elem.appendChild(usersElem);

		for (let id in users) {
			let user = users[id];
			let userLink = document.createElement("a");
			userLink.classList.add("list-group-item");
			userLink.href = router.generateUrl("user.detail", {id: user.id});
			userLink.addEventListener("click", navigateToHref);
			userLink.textContent = user.display_name;

			usersElem.appendChild(userLink);
		}

		main.appendChild(elem);
	});
}

export {
	showFriends,
	showInviteFriend,
	showMe,
	showUserDetail,
	showUserEdit,
	showUserList,
};
